(function (ss) {
  ss.setup_instruments_interaction = function () {
    var s;
    const player = window.player;

    window.linkedInShareSuccess = function () {
      _gaq.push(['_trackEvent', 'bigfoot_slideview', 'viralshareLinkedIn']);
    };

    $.fn.extend({
      // click and stop event propagation or browser defaults
      evt_track: function (category, action, optional_label, optional_value, tracker) {
        return this.click(function (event) {
          window._gaq.push(['_trackEvent', category, action, optional_label, optional_value]);
          return true;
        });
      },
      evt_trackAjaxOkay: function (category, action, optional_label, optional_value, tracker) {
        return this.bind('ajaxOkay', function () {
          window._gaq.push(['_trackEvent', category, action, optional_label, optional_value]);
          return true;
        });
      }
    });

    $('.j-download', ss.svTools).evt_track('bigfoot_slideview', 'downloadclick>' + (ss.user.loggedin ? "loggedin" : "loggedout"));

    // Register author panel load
    var authorPanel = $('.j-author-panel');
    if(authorPanel.size() > 0){
      window._gaq.push(['_trackEvent', 'author-panel', 'pageload']);
    }

    //  If this slideview load is from search results page
    if(document.referrer.match(/search\/slideshow/)){
      var resultNum = getUrlVar('from_search');
      if(resultNum !== undefined){
        //  send an event for pageload
        window._gaq.push(['_trackEvent', 'searchresult', 'slideview_load_' + resultNum]);
        //  trigger event if user downloads
        $('.j-download', ss.svTools).evt_track('searchresult', 'downloadclick_' + resultNum);
      }
    }

    //  if slideview is referred from search results and the user has
    //  viewed slides in multiples of 10 percentages, 10%, 20%...
    //  trigger a GA event
    if(typeof player !== 'undefined' && $(player)){
      $(player).bind('next', function(e){
        if(document.referrer.match(/search\/slideshow/)){
          var lastPosition = player.controller.slideCount;
          var nextSlide = player.controller.currentPosition;
          var currDepthOfView = Math.ceil((100.0 * nextSlide)/lastPosition);
          var lastDepthOfView = Math.ceil((100.0 * (nextSlide - 1))/lastPosition);
          var lastMultipleOf10 = currDepthOfView - (currDepthOfView % 10);
          if(lastDepthOfView < lastMultipleOf10){
            var resultNum = getUrlVar('from_search');
            if(resultNum && window._gaq){
              resultNum = resultNum.split('#')[0];
              window._gaq.push(['_trackEvent','searchresult', 'view_' + resultNum + '_' + lastMultipleOf10]);
            }
          }
        }
      });
    }

    if (ss.promoted) {
      window._gaq.push(['_trackEvent', 'bigfoot_slideview', 'promoted', 'show']);
      $('#relatedList li:lt(' + ss.promoted + ')').evt_track('bigfoot_slideview', 'promoted', 'click');
    }

    if (ss.contests) {
      $.each(ss.contests, function (index, contest) {
        window._gaq.push(['_trackEvent', "bigfoot_contest", contest.contestLink, "slideview"]);
      });
    }

    //Only for flash player
    if (ss.player) {
      if ((jQuery('#noflash').length === 0) || (jQuery('#noflash').is(':visible') === false)) {
        // log player load
        var playerurl = ss.player.url;
        if (playerurl.match('swf/ssplayer2.swf')) {
          window._gaq.push(['_trackEvent', 'bigfoot_slideview', 'playerload', 'normal']);
        } else if (playerurl.match('swf/playerv.swf')) {
          window._gaq.push(['_trackEvent', 'bigfoot_slideview', 'playerload', 'video']);
        } else if (playerurl.match('swf/doc_player.swf')) {
          window._gaq.push(['_trackEvent', 'bigfoot_slideview', 'playerload', 'doc']);
        } else {
          window._gaq.push(['_trackEvent', 'bigfoot_slideview', 'playerload', 'a9']);
        }
      }
    }

    ss.last_iframe = null;
    jQuery('.lostchild').mouseenter(function (event) {
      ss.last_iframe = event.target;
    });
    jQuery('.lostchild').mouseleave(function (event) {
      ss.last_iframe = null;
    });
    window.track_beforeunload_event = function () {
      if (ss.last_iframe) {
        ss.last_iframe = $(ss.last_iframe).parents('.lostchild')[0] || ss.last_iframe;
        var identifier = ss.last_iframe.className.replace(/lostchild|adbox-outer/g,
          '').replace(/^\s+|\s+$/g, '').split(/\s+/).sort().join(' ');
        ss.last_iframe = null;
      }
    };
    var old_onbeforeunload = window.onbeforeunload;
    window.onbeforeunload = function () {
      var value = window.track_beforeunload_event();
      value = value || (old_onbeforeunload && old_onbeforeunload.apply(window, arguments));
      if (value) {
        return value;
      }
    };
    jQuery(document).blur(window.track_beforeunload_event);
  };

  if(!ss.slideshow.is_private) {
    Number.prototype.number_with_delimiter = function(delimiter) {
      var i18n_locale = slideshare_object.utils.i18n_locale();

      //adding delimiter to numbers is dependent on locale. Each locale
      // handles it differently. Using xmessage will make this operation
      // locale safe.
      // Keeping old code for pages where xmessage is not loaded
      if(window.xmessage && i18n_locale){
        var fn = window.xmessage.fromString("{0,number}", i18n_locale);
        return fn([this]);
      } else {
        var number = this + '';
        delimiter = delimiter || ',';
        var split = number.split('.');
        split[0] = split[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + delimiter
        );
        return split.join('.');
      }
    };
  }

})(slideshare_object);
